/**
 * Number Format Utility
 * จัดการ format ตัวเลข เช่น การแสดง , ในตัวเลข
 */

// const formatTHB = (amount) => new Intl.NumberFormat('th-TH', { maximumFractionDigits: 0 }).format(amount);

export const formatTHB = (amount) => {
  if (amount === null || amount === undefined) return '';
  return new Intl.NumberFormat('th-TH', { maximumFractionDigits: 0 }).format(amount);
};